import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AmendHpDeviceProgressStepper from "./components/amendHpDeviceProgressStepper"
import CoreHpDeviceDetails from "./formPages/coreHpDeviceDetails"
import ReviewAndSubmitHpDevice from "./formPages/reviewAndSubmitHpDevice"
import { AmendHpDeviceContext } from "./providers/baseProviders/amendHpDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { HpDeviceFormData } from "../types/providerTypes"

/** The form for amending an HP device */
const AmendHpDeviceForm = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppCard>
            <AppCardContent>
                <AmendHpDeviceProgressStepper />
            </AppCardContent>
        </AppCard>

        <MultiPageForm context={AmendHpDeviceContext}>
            <CoreHpDeviceDetails context={AmendHpDeviceContext} />
            <LctDeviceAttachments<HpDeviceFormData>
                context={AmendHpDeviceContext}
                dataset={Datasets.HP}
                isAmendment
            />
            <ReviewAndSubmitHpDevice
                context={AmendHpDeviceContext}
                isAmendment
            />
        </MultiPageForm>
    </Stack>
)

export default AmendHpDeviceForm
